const { formatText } = require("core/i18n").i18n;
const {DEFAULT_TRANSLATION_TEXT_MISSING_VALUE, DEFAULT_TRANSLATION_TEXT} = require('../../constants')
const isValidKey = (key) => {
    const translation = formatText(key);
    return (
        translation !== DEFAULT_TRANSLATION_TEXT_MISSING_VALUE &&
        translation !== DEFAULT_TRANSLATION_TEXT
    );
}

export { isValidKey };